import { render, staticRenderFns } from "./ParticaBaseView.vue?vue&type=template&id=7171732d&"
import script from "./ParticaBaseView.vue?vue&type=script&lang=ts&"
export * from "./ParticaBaseView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports